import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceCategorySelect from "~/components/booking/flow/ServiceCategorySelect";
import { SHOW_CONFIRM_ON_AUTO_ADVANCE_STEPS } from "~/components/booking/flow/confirmButton";
import { Button } from "~/components/ui/Button";

const ServiceCategoryStep = ({
  disableConfirm = false,
  onConfirm,
  onChange,
  onCancel,
  selectedDate,
  onSkip,
  guestsCount,
  availabilitiesForDate,
  defaultSelectedAvailability,
}: {
  disableConfirm?: boolean;
  onChange: () => void;
  onCancel: () => void;
  onConfirm: (selectedAvailability: any) => void;
  selectedDate: Date;
  onSkip: (availability: any) => void;
  guestsCount: { male: number; female: number };
  availabilitiesForDate: any[];
  defaultSelectedAvailability?: any;
}) => {
  const { t } = useTranslation();
  const [selectedAvailability, setSelectedAvailability] = useState<any>(
    defaultSelectedAvailability
  );


  return (
    <div id="step-service-category" className="w-full flex flex-col px-8 py-8">
      <ServiceCategorySelect
        onSkip={onSkip}
        availabilities={availabilitiesForDate}
        guestsCount={guestsCount}
        selectedValue={selectedAvailability}
        onSelect={(availability) => {
          if (availability !== selectedAvailability) {
            onChange();
          }
          setSelectedAvailability(availability);
          // Single-choice step: picking a card moves straight to the next step.
          if (!disableConfirm) {
            onConfirm(availability);
          }
        }}
      />
      <div className="w-full flex flex-row items-center justify-center space-x-2 mt-4">
        <Button
          variant={"muted"}
          onClick={() => {
            onCancel();
          }}
        >
          <span>{t("Indietro")}</span>
        </Button>
        {SHOW_CONFIRM_ON_AUTO_ADVANCE_STEPS && (
          <Button
            disabled={!selectedAvailability || disableConfirm}
            variant={"secondary"}
            onClick={() => {
              onConfirm(selectedAvailability);
            }}
          >
            <span>{t("Conferma")}</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ServiceCategoryStep;
